import CreateStockOrderProductInfo from './create-stockorder-product';
export default class CreateStockOrder {
    id: number;
    pdfGuid: string;
    orderNumber: string;
    storeId: number;
    reMark: string;
    orderProductInfosList: Array<CreateStockOrderProductInfo>;
    cargoCategory?: number;
    shippingMethods: string;
    site?: number;
    constructor() {
        this.orderProductInfosList = [];
        this.site = 4;
    }
}